/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateTeamRequest
 */
export interface CreateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTeamRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeamRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateTeamRequest interface.
 */
export function instanceOfCreateTeamRequest(value: object): boolean {
    return true;
}

export function CreateTeamRequestFromJSON(json: any): CreateTeamRequest {
    return CreateTeamRequestFromJSONTyped(json, false);
}

export function CreateTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateTeamRequestToJSON(value?: CreateTeamRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

